<!-- <form nz-form [formGroup]="formGroup" (ngSubmit)="submit()" *ngIf="formGroup">
  <div class="page-content-section">
    <fieldset>
      <legend>Information</legend>
      <nz-row>
        <nz-form-item nzFlex nz-col nzSm="24" nzMd="12" *ngIf="mode === 'edit'">
          <nz-form-label
            [nzSm]="24"
            [nzXs]="24"
            nzRequired
            [nzNoColon]="true"
            nzFor="Code">
            Id
          </nz-form-label>
          <nz-form-control
            [nzSm]="24"
            [nzXs]="24"
            nzErrorTip="Please insert the id."
          >
            <input nz-input formControlName="Id" id="Id" readonly />
          </nz-form-control>
        </nz-form-item>
  
        <nz-form-item nzFlex nz-col nzSm="24" nzMd="12">
          <nz-form-label
            [nzSm]="24"
            [nzXs]="24"
            nzRequired
            [nzNoColon]="true"
            nzFor="Name"
          >
            Name
          </nz-form-label>
          <nz-form-control
            [nzSm]="24"
            [nzXs]="24"
            nzErrorTip="Please insert the name."
          >
            <input nz-input formControlName="Name" id="Name" />
          </nz-form-control>
        </nz-form-item>
  
        <nz-form-item nzFlex nz-col nzSm="24" nzMd="12">
          <nz-form-label
            [nzSm]="24"
            [nzXs]="24"
            [nzNoColon]="true"
            nzFor="ClonedCategories"
          >
            Cloned Categories
          </nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24">
            <nz-select
              nzMode="tags"
              nzShowSearch
              formControlName="ClonedCategories"
            >
              <nz-option
                *ngFor="let cat of categories"
                [nzValue]="cat.Id"
                [nzLabel]="cat.Name"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </nz-row>
  
      <input nz-input formControlName="ParentId" hidden id="ParentId" />
    </fieldset>
  </div>

  <div class="page-content-section" *ngIf="languages.length > 0">
    <ng-container [formGroup]="translationFormGroup">
      <fieldset>
        <legend>Translations</legend>
        <nz-row>
          <nz-form-item
            nzFlex
            nz-col
            nzSm="24"
            nzMd="12"
            *ngFor="let lang of languages"
          >
            <nz-form-label
              [nzSm]="24"
              [nzXs]="24"
              [nzNoColon]="true"
              nzFor="ClonedCategories"
            >
              {{ lang.Label }}
            </nz-form-label>
            <nz-form-control
              [nzSm]="24"
              [nzXs]="24"
              nzErrorTip="Please insert the name."
              *ngIf="translationFormGroup.get(lang.Code.toString()) != null"
            >
              <input nz-input [formControlName]="lang.Code" />
            </nz-form-control>
          </nz-form-item>
        </nz-row>
      </fieldset>
    </ng-container>
  </div>


  <app-custom-attributes
  [objectTypeId]="6"
  [isBulkEdit]="false"
  [record]="record"
  (attributeGroupsLoaded)="onAttributeGroupsLoaded($event)"
  formGroupName="AttributeValues"
>
</app-custom-attributes>


  <app-related-products
  [products]="relatedProducts"
  (selectedProductsChanged)="onRelatedProductsChange($event)"
></app-related-products>

<input type="submit" style="display: none" />
</form>  -->


<nz-row [nzGutter]="16">
  <!-- column Left  -->
  <nz-col [nzSpan]="8">
    <div class="form-wrapper">
      <form [formGroup]="formGroup" nzLayout="vertical" (ngSubmit)="submit()" *ngIf="formGroup">

        <!-- Hidden Id -->
        <!-- <input nz-input formControlName="id" type="hidden" /> -->

        <!-- Hidden ParentId -->
        <input nz-input formControlName="ParentId" type="hidden" />


        <nz-form-item>
          <nz-form-label [nzFor]="'Name'" [nzSpan]="24">{{'Name' | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input formControlName="Name" placeholder="Enter Category Name" required />
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label [nzSm]="24" [nzXs]="24" [nzNoColon]="true" nzFor="ClonedCategories" style="text-align: left;">
            {{'Cloned Categories' | translate }}
          </nz-form-label>
          <nz-form-control [nzSm]="24" [nzXs]="24">
            <nz-select style="width: 100%;" nzMode="tags" nzShowSearch formControlName="ClonedCategories">
              <nz-option *ngFor="let cat of categories" [nzValue]="cat.Id" [nzLabel]="cat.Name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>


        <app-custom-attributes [objectTypeId]="6" [isBulkEdit]="false" [record]="record"
          (attributeGroupsLoaded)="onAttributeGroupsLoaded($event)" formGroupName="AttributeValues">
        </app-custom-attributes>


        <input type="submit" style="display: none" />
      </form>
    </div>
  </nz-col>

  <!-- column R -->
  <nz-col [nzSpan]="16">
    <nz-skeleton *ngIf="isLanguagesLoading" [nzActive]="true" [nzParagraph]="true"></nz-skeleton>
    <!-- *ngIf="!isLanguagesLoading && languages.length > 0" -->
    <div class="card-container">
      <nz-tabset nzType="card">

        <!-- Related Products -->
        <nz-tab
          [nzTitle]="('Related Products' | translate) + (relatedProducts && relatedProducts.length > 0 ? ' (' + relatedProducts.length + ')' : ' (0)')">
          <div style="max-height: 600px; overflow-y: auto;">

            <nz-spin nzSimple *ngIf="isLoad"></nz-spin>
            <ng-container *ngIf="!isLoad">
              <app-dynamic-catalog [typeLabel]="'Category type'" [smartLabel]="'Smart Category'"
                [catalogId]="categoryId" [objectType]="6" [mode]="catalogMode" [tabIndex]="tabIndex"
                (tabIndexChange)="onTabIndexChange($event)" (products)="receiveProducts($event)"
                (filter)="receiveFilter($event)" (clearConditionEvent)="handleClearCondition()"
                (productIdsChange)="receiveProductIds($event)"
                (isLoadingProduct)="onLoadingChanged($event)"></app-dynamic-catalog>
            </ng-container>
            <nz-divider></nz-divider>

            <nz-spin *ngIf="loadingProduct" nzSimple
              style="display: flex; justify-content: center; align-items: center; height: 200px;">
            </nz-spin>
            <ng-container *ngIf="!loadingProduct">
              <app-related-products [typeLabel]="tabIndex" [products]="relatedProducts" [categoryId]="categoryId"
                (refrshRelatedProduct)="refrsh()"
                (selectedProductsChanged)="onRelatedProductsChange($event)"></app-related-products>
            </ng-container>

          </div>
        </nz-tab>
        <!-- Translations -->
        <nz-tab nzTitle="Translations">

          <div class="page-content-section">
            <ng-container [formGroup]="translationFormGroup">
              <fieldset>

                <nz-row>
                  <nz-form-item nzFlex nz-col nzSm="24" nzMd="12" *ngFor="let lang of languages">
                    <nz-form-label [nzSm]="24" [nzXs]="24" [nzNoColon]="true" nzFor="ClonedCategories">
                      {{ lang.Label }}
                    </nz-form-label>
                    <nz-form-control [nzSm]="24" [nzXs]="24" nzErrorTip="Please insert the name."
                      *ngIf="translationFormGroup.get(lang.Code.toString()) != null">
                      <input nz-input [formControlName]="lang.Code" />
                    </nz-form-control>
                  </nz-form-item>
                </nz-row>
              </fieldset>
            </ng-container>
          </div>

        </nz-tab>
      </nz-tabset>
    </div>
  </nz-col>
</nz-row>